export enum RolesEnum {
  admin = 'admin',
  instructor = 'instructor',
  participant = 'participant',
}
